/**
 * Highest phase conductor current of a cable segment in A.
 *
 * NH fuses and the thermal cable rating both act per conductor, so every
 * "Strom" shown next to a loading or fuse loading must be this figure — the
 * same one the backend builds loadingPercent from (I_max / I_n).
 *
 * currentA already carries the highest phase since 2026-09-14; the explicit
 * max over L1..L3 keeps archived playback frames from before that date
 * consistent (their current_a is the quadratic mean, up to 1/√3 smaller).
 * Falls back to |currentA| when no per-phase values are present.
 */
export interface PhaseCurrentSource {
  currentA?: number | null;
  currentL1A?: number | null;
  currentL2A?: number | null;
  currentL3A?: number | null;
}

export function maxPhaseCurrentA(seg: PhaseCurrentSource | null | undefined): number {
  if (!seg) return 0;
  const phases = [seg.currentL1A, seg.currentL2A, seg.currentL3A]
    .filter((v): v is number => typeof v === 'number' && Number.isFinite(v))
    .map(v => Math.abs(v));
  const maxPhase = phases.length > 0 ? Math.max(...phases) : 0;
  return maxPhase > 0 ? maxPhase : Math.abs(seg.currentA ?? 0);
}
